import { createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
import { DepartmentModel } from "@tCooneyBrothers/ApiModels";
import { getDepartments } from "@tCooneyBrothers/Services/DepartmentService";
import { CustomHandlerWithResult } from "@tCooneyBrothers/Store/CustomHandlerCreator";

type HandlerType = CustomHandlerWithResult<
    {},
    {
        apiResult: DepartmentModel[];
    },
    {}
>;

export const DispatchBeginLoadDepartments: HandlerType = props => {
    props.dispatch({
        type: "Data/Department/BeginLoadDepartments",
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.result = {
        apiResult: await getDepartments(),
    };
};

export const DispatchCompleteLoadDepartments: HandlerType = props => {
    props.dispatch({
        type: "Data/Department/CompleteLoadDepartments",
        result: props.result.apiResult || [],
    });
};

export const chain = [DispatchBeginLoadDepartments, RequestDataFromApi, DispatchCompleteLoadDepartments];

const loadDepartments = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadDepartments");
export default loadDepartments;
